/**
 *
 *
 *
 *
 *
 *
 */
import { useSyncExporter } from "../common/useSyncExporter.js";
import { debugSync, type DebugSync } from "../globals/debug.js";

export type * from "../lib/debug/index.js";

const asExport = useSyncExporter(() => debugSync);

export {
  /*                                                                    */
  debugSync,
};

/**
 *
 */
export const logger: DebugSync["logger"] = asExport("logger");

/**
 *
 */
export const scope: DebugSync["scope"] = asExport("scope");

/**
 *
 */
export const Level: DebugSync["Level"] = debugSync.Level;

/**
 *
 */
export const status: DebugSync["status"] = asExport("status");
